module.exports = __webpack_public_path__ + "img/95.27fc77b0.jpg";